import React from 'react';
import { Col, Form } from 'react-bootstrap';

// TextArea
const TextAreaInput = ({ c, i, valuesRequired, handleInputChange }) => {
  return (
    <Col lg={12} xs={12} className="mb-3" key={'form-bodyform-' + i}>
      <Form.Group controlId={'validationCustom' + i}>
        <Form.Label>
          {c.required ? c.name + ' *' : c.name + ' (opcional)'}
        </Form.Label>
        <Form.Control
          as="textarea"
          name={!c.required ? '_' + c.name : c.name}
          required={c.required}
          onChange={handleInputChange}
          placeholder={c.placeholder}
          style={{ height: '80px' }}
          className="text-black"
          minLength={c.required ? 3 : 0}
          maxLength="300"
          isValid={
            (c.required &&
              valuesRequired.content[c.name] !== undefined &&
              valuesRequired.content[c.name]?.length > 2) ||
            (!c.required &&
              valuesRequired.content['_' + c.name] !== undefined &&
              valuesRequired.content['_' + c.name]?.length > 2)
          }
          isInvalid={
            c.required &&
            valuesRequired.content[c.name]?.length > 0 &&
            valuesRequired.content[c.name]?.length <= 2
          }
        />
        <Form.Control.Feedback type="invalid">
          Cuéntanos un poco más por favor.
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );
};

export default TextAreaInput;
